import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roadSegments: null,
  status: 'idle',
  error: null,
};

const roadSegmentsSlice = createSlice({
  name: 'roadSegments',
  initialState,
  reducers: {
    setRoadSegments: (state, action) => {
      state.roadSegments = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setRoadSegments, setError, setLoading } =
  roadSegmentsSlice.actions;
export default roadSegmentsSlice.reducer;
